<template>
  <div>
		<div id="editor" type="text/plain"></div>
  </div>
</template>
<script>
import '../../../public/UEditor/ueditor.config.js'
import '../../../public/UEditor/ueditor.all.js'
import '../../../public/UEditor/lang/zh-cn/zh-cn.js'
import '../../../public/UEditor/ueditor.parse.min.js'
export default {
    name: 'UE',
    data () {
      return {
        editor: null
      }
    },
    props: {
      config: {
        type: Object
      }
    },
    mounted() {
        const _this = this;
        this.editor = UE.getEditor('editor', this.config);   // 初始化UE
    },
    methods: {
      getUEContent() { // 获取内容方法
        return this.editor.getContent();
      },
      setText(con) {  //设置内容
				this.editor.addListener("ready",function(){
            this.editor = UE.getEditor('editor', this.config);  
            this.editor.setContent(con); 
         })
				 this.editor.setContent(con); 
             
      }
    },
    unmounted() {
      this.editor.destroy();
    }
  }
</script>